module.exports = __webpack_public_path__ + "svg/logo-bib-bom.svg";